/**
 * Список организаций владельца: разбиение на черновики и опубликованные.
 *
 * Разделение нужно не ради красоты. Новая организация — черновик, в каталог она попадает
 * по кнопке и только заполненной (README, решение 3), и черновик, лежащий вперемешку
 * с опубликованными под одинаковым бейджем, читается как «уже работает». Владелец ждал бы
 * клиентов из каталога, которых там нет.
 */

import type { CabinetBusinessDto } from '../../../api/cabinetTypes';

export interface BusinessGroups {
  /** Видны клиентам в каталоге. */
  readonly published: readonly CabinetBusinessDto[];
  /** Ещё не в каталоге: не хватает услуги, специалиста или просто не нажата кнопка. */
  readonly drafts: readonly CabinetBusinessDto[];
  /**
   * Архив («История»). Ни в черновики, ни в каталог он не попадает: архивная организация уже
   * не рабочая, и вперемешку с живыми читалась бы как «ещё работает».
   */
  readonly history: readonly CabinetBusinessDto[];
}

/**
 * Черновики идут первыми на экране, потому что именно они требуют действия. Внутри каждой
 * группы порядок сервера сохраняется: он задан выдачей API, и пересортировка здесь развела
 * бы список с тем, что видит бэкенд, без единой причины.
 */
export function splitByPublication(items: readonly CabinetBusinessDto[]): BusinessGroups {
  const published: CabinetBusinessDto[] = [];
  const drafts: CabinetBusinessDto[] = [];
  const history: CabinetBusinessDto[] = [];
  for (const item of items) {
    // Архив проверяется первым и по `archivedAt`: снятый при архивации `isPublished` —
    // следствие, а не признак, и остаточный флаг не должен вернуть организацию на главный экран.
    if (item.archivedAt !== null) history.push(item);
    else if (item.isPublished) published.push(item);
    else drafts.push(item);
  }
  return { published, drafts, history };
}
